<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Add Logo</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/logos" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createLogo" v-if="logo">
                <div class="row justify-content-md-center">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-md-4">
                        <fg-input type="text"
                                  v-model="logo.siteNameText"
                                  label="Site Name"
                                  placeholder="Enter Name"
                                  v-validate="rules.siteNameText"
                                  data-vv-name="site"
                                  cus-name="site"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-4">
                        <fg-input type="text"
                                  v-model="logo.linkDestination"
                                  label="Site URL"
                                  placeholder="Enter URL"
                                  v-validate="rules.linkDestination"
                                  data-vv-name="URL"
                                  cus-name="URL"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-4" v-if="pages.length">
                        <fg-select
                          v-model="logo.pageName"
                          label="Page"
                          v-validate="rules.pageName"
                          data-vv-name="pageName"
                          cus-name="pageName"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="pages"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                      <div class="col-md-12">
                        <fg-input type="text"
                                  v-model="logo.logoUrl"
                                  label="Logo URL (200 X 200)"
                                  placeholder="Enter Logo URL"
                                  v-validate="rules.logoUrl"
                                  data-vv-name="logo URL"
                                  cus-name="logo URL"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-3" v-if="status.length">
                        <fg-select
                          v-model="logo.active"
                          label="Status"
                          v-validate="rules.active"
                          data-vv-name="active"
                          cus-name="active"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="status"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                    </div>
                  </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Create Logo
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreateLogo',
        created (){
    },
    data () {
        return {
            logo: {
              logoUrl: '',
              siteNameText: '',
              linkDestination: '',
              pageName: '',
              active: '1'
            },
            active: 1,
            status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
            pages: [{name:'Select Page'}, {id:"B2B", name:'B2B'}, {id:"UNAUTH", name:'UNAUTH'}],
            rules: {
              logoUrl: {required : true},
              siteNameText: {required : true},
              linkDestination: {required : true},
              pageName: {required: true},
              active: {required: true}
            },
            message: {
                error: false,
                text: ''
            }
        }
    },
    methods: {
        createLogo () {
          console.log("this.logo : ", this.logo);
          this.$validator.validateAll().then((result) => {
            if(result){
              this.$store.dispatch('ADD_LOGO', this.logo)
                .then((res) => {
                  console.log("ADD_LOGO res : ", res);
                  if(res) this.showPopup('Success!', 'Logo is successfully created', 'success', ()=>this.$router.push('/admin/logos'))
                  else this.showPopup('Error!', 'Unable to process.', 'error')
                })
                .catch(err => {
                  this.showPopup('Error!', 'some thing happen wrong', 'error')
                  console.log("ADD_LOGO API error : ", err);
                })
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    created() {

    },

    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Logos/CreateLogo.vue